import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen bg-gray-50 overflow-hidden" }
const _hoisted_2 = { class: "bg-gradient-to-b from-gray-900 to-gray-800 relative text-white w-64 flex flex-col shadow-2xl flex-shrink-0" }
const _hoisted_3 = { class: "p-6 border-b border-gray-700" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "w-10 h-10 bg-[#8C0004] rounded-lg flex items-center justify-center flex-shrink-0" }
const _hoisted_6 = { class: "flex-1 py-6 overflow-y-auto" }
const _hoisted_7 = { class: "space-y-1 px-3" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "p-4 border-t border-gray-700" }
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = { class: "w-10 h-10 bg-gradient-to-br from-[#8C0004] to-red-800 rounded-full flex items-center justify-center flex-shrink-0" }
const _hoisted_12 = { class: "flex-1 min-w-0" }
const _hoisted_13 = { class: "font-medium text-sm truncate" }
const _hoisted_14 = { class: "text-xs text-gray-400 truncate" }
const _hoisted_15 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_16 = {
  key: 0,
  class: "bg-amber-100 border-b border-amber-300 px-8 py-2 flex items-center gap-2 text-amber-900 text-sm"
}
const _hoisted_17 = {
  key: 1,
  class: "bg-red-100 border-b border-red-300 px-8 py-2 flex items-center gap-2 text-red-900 text-sm"
}
const _hoisted_18 = { class: "bg-white shadow-sm border-b border-gray-200 px-8 py-4" }
const _hoisted_19 = { class: "flex items-center justify-between gap-4" }
const _hoisted_20 = { class: "min-w-0" }
const _hoisted_21 = { class: "text-2xl font-bold text-gray-800" }
const _hoisted_22 = { class: "text-sm text-gray-500 mt-1" }
const _hoisted_23 = { class: "flex items-center gap-3 flex-shrink-0" }
const _hoisted_24 = { class: "text-right hidden md:block" }
const _hoisted_25 = { class: "text-sm font-semibold text-gray-800 truncate max-w-[200px]" }
const _hoisted_26 = { class: "flex bg-gray-100 rounded-lg p-1" }
const _hoisted_27 = { class: "flex-1 overflow-y-auto p-8" }

import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Icon } from '@iconify/vue'
import { useAuthStore } from '../store/auth'
import { useModeStore } from '../store/mode'
import type { ApiMode } from '../services/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const modeStore = useModeStore()

const menuItems = [
  { name: 'Tableau de bord', path: '/dashboard', icon: 'solar:chart-2-bold' },
  { name: 'Livraisons', path: '/orders', icon: 'solar:box-bold' },
  { name: 'Clés API', path: '/api-keys', icon: 'solar:key-bold' },
  { name: 'Webhooks', path: '/webhooks', icon: 'solar:bell-bold' },
  { name: 'Documentation', path: '/docs', icon: 'solar:document-text-bold' },
  { name: 'Paramètres', path: '/settings', icon: 'solar:settings-bold' },
]

const pageSubtitles: Record<string, string> = {
  '/dashboard': 'Vue d\'ensemble de votre activité',
  '/orders': 'Les livraisons créées via votre intégration',
  '/api-keys': 'Créez et révoquez les clés qui authentifient vos requêtes',
  '/webhooks': 'Recevez les événements de livraison et de paiement en temps réel',
  '/docs': 'Référence de l\'API et console de test',
  '/settings': 'Votre compte, votre équipe et votre facturation',
}

const pageTitle = computed(() => {
  const item = menuItems.find((i) => i.path === route.path)
  return item?.name || 'Portail Partenaire'
})

const pageSubtitle = computed(() => pageSubtitles[route.path] || '')

function isActive(path: string): boolean {
  return route.path === path
}

function switchMode(mode: ApiMode) {
  if (modeStore.mode === mode) return
  modeStore.setMode(mode)
}

async function logout() {
  await authStore.logout()
  router.push('/login')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Icon), {
              icon: "solar:code-square-bold",
              class: "w-6 h-6"
            })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "font-bold text-lg" }, "Youdégo"),
            _createElementVNode("p", { class: "text-xs text-gray-400" }, "Portail Partenaire")
          ], -1))
        ])
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
            return _createElementVNode("li", {
              key: item.name
            }, [
              _createVNode(_component_router_link, {
                to: item.path,
                class: _normalizeClass([
                'flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200',
                isActive(item.path)
                  ? 'bg-[#8C0004] text-white shadow-lg'
                  : 'text-gray-300 hover:bg-gray-700/50 hover:text-white'
              ])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: item.icon,
                    class: "w-6 h-6 flex-shrink-0"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(Icon), {
              icon: "solar:user-bold",
              class: "w-5 h-5"
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(authStore).fullName), 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(authStore).isOwner ? 'Propriétaire' : 'Développeur'), 1)
          ])
        ]),
        _createElementVNode("button", {
          onClick: logout,
          class: "mt-3 w-full flex items-center justify-center gap-2 px-4 py-2 bg-gray-700/50 hover:bg-gray-700 rounded-lg transition-colors text-sm"
        }, [
          _createVNode(_unref(Icon), {
            icon: "solar:logout-2-bold",
            class: "w-5 h-5"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Déconnexion", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_unref(modeStore).isTest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_unref(Icon), {
              icon: "solar:test-tube-bold",
              class: "w-4 h-4 flex-shrink-0"
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Mode test"),
              _createTextVNode(" — vous travaillez dans le bac à sable : les livraisons sont simulées, aucun livreur réel n'est sollicité et aucun paiement n'est encaissé. ")
            ], -1))
          ]))
        : _createCommentVNode("", true),
      (_unref(authStore).isSuspended)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_unref(Icon), {
              icon: "solar:danger-triangle-bold",
              class: "w-4 h-4 flex-shrink-0"
            }),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Compte suspendu"),
              _createTextVNode(" — vos clés API sont refusées et le portail est en lecture seule. Contactez le support Youdégo. ")
            ], -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("header", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h2", _hoisted_21, _toDisplayString(pageTitle.value), 1),
            _createElementVNode("p", _hoisted_22, _toDisplayString(pageSubtitle.value), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(authStore).partner?.name), 1),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Environnement", -1))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (switchMode('TEST'))),
                class: _normalizeClass([
                  'px-3 py-1.5 rounded-md text-sm font-semibold transition-colors',
                  _unref(modeStore).isTest
                    ? 'bg-amber-500 text-white shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                ])
              }, " Test ", 2),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (switchMode('LIVE'))),
                class: _normalizeClass([
                  'px-3 py-1.5 rounded-md text-sm font-semibold transition-colors',
                  _unref(modeStore).isLive
                    ? 'bg-emerald-600 text-white shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                ])
              }, " Live ", 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_27, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _unref(modeStore).mode
        }))
      ])
    ])
  ]))
}
}

})